import { CircularProgress, Stack, Typography } from '@mui/material'

/**
 * Estado de carga con lenguaje de investigación ("Analizando…",
 * "Consultando evidencia…") — nunca términos técnicos (tool_call, OpenAI,
 * tokens, provider), mismo principio ya aplicado en el streaming de GOVIA
 * AI (Fase C). `skeleton` cubre el caso de layout ya conocido (fila/tarjeta
 * repetida) — para eso, usar `Skeleton` de MUI directamente, no este
 * componente (este es para el caso "estoy trabajando en tu pregunta").
 */
export function LoadingIntelligenceState({ label = 'Analizando información…' }: { label?: string }) {
  return (
    <Stack direction="row" alignItems="center" spacing={1.25} sx={{ py: 3 }}>
      <CircularProgress size={16} thickness={5} />
      <Typography variant="body2" color="text.secondary">
        {label}
      </Typography>
    </Stack>
  )
}
